'use client';

import { useContext } from 'react';
import { AuthContext, AuthContextType } from '@/components/SessionProvider';

export type { AuthState } from '@/components/SessionProvider';

/**
 * Client-side auth hook.
 * Returns user, their crew_id (if crew/crew_lead), loading state, and whether auth is enabled.
 */
export function useAuth(): AuthContextType {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within a SessionProvider');
  }
  return context;
}

